
const SpeakersData = [
    {
        img: '/Images/Speakers/speaker.png',
        day: "11",
        month: "Apr",
        name: "Aman Priyadarshi",
        post: "Web Developer",
    },
    {
        img: '/Images/Speakers/speaker.png',
        day: "11",
        month: "Apr",
        name: "Aman Priyadarshi",
        post: "Web Developer",
    },
    {
        img: '/Images/Speakers/speaker.png',
        day: "11",
        month: "Apr",
        name: "Aman Priyadarshi",
        post: "Web Developer",
    },
    {
        img: '/Images/Speakers/speaker.png',
        day: "11",
        month: "Apr",
        name: "Aman Priyadarshi",
        post: "Web Developer",
    },
    {
        img: '/Images/Speakers/speaker.png',
        day: "11",
        month: "Apr",
        name: "Aman Priyadarshi",
        post: "Web Developer",
    },
    {
        img: '/Images/Speakers/speaker.png',
        day: "11",
        month: "Apr",
        name: "Aman Priyadarshi",
        post: "Web Developer",
    },
]

export default SpeakersData;